import React from 'react';
import Add from './add';

class View extends React.Component {

  state = {

  }

  render() {
    let i = 0;
    return (
      <div>
        <table id="table" width="100%">
          <tr>
            <th id="tableheader"><center>Sino</center></th>
            <th id="tableheader"><center>Mode</center></th>
            <th id="tableheader"><center>Code</center></th>
            <th id="tableheader"><center>Status</center></th>
            { this.props.menuPermission.edit ?
              <th id="tableheader"><center>Edit</center></th>:''
            }
            
          </tr>
          { this.props.data.map((x) => {
              i++;
              return (
                <tr>
                  <td><center>{i}</center></td>
                  <td><center>{x.mode}</center></td>
                  <td><center>{x.code}</center></td>
                  <td><center>{x.status}</center></td>
                  { this.props.menuPermission.edit ?
                    <td>
                      <center>
                        <Add mode={x.mode} status={x.status}
                            id={x.id} type={'edit'} getMode={this.props.getMode} />
                      </center>
                    </td>:''
                  }
                </tr>
              )
            })
          }
        </table>
      </div>
    );
  }
}

export default View;
